import React from 'react';
import './TalkToProject.css';

function TalkToProject() {
  return (
    <section className="container pt-3 pt-md-4 pt-lg-5 pb-2 mt-lg-2 mt-xl-4">
    <div className="row align-items-center">
      <div className="rellax col-12 col-lg-5 col-xl-5 mb-4 mb-lg-0 px-3 px-sm-4 px-lg-3" data-rellax-percentage="0.5" data-rellax-speed="0.8" data-disable-parallax-down="lg">
        <h2 className="pt-2 pt-lg-0">Your AI Quality Team, <br/> On Demand</h2>
        <p className="fs-lg">
        Ask a quick question or put the full AI quality control team to work.
          </p>
        <div className="row g-2 pb-2">
          <div className="col-12 col-sm-6 col-lg-12">
            <div className="qt-card">
              <span>Run a full compliance audit on Project Falcon and flag any outstanding issues.</span>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-lg-12">
            <div className="qt-card">
              <span>Identify any discrepancies between submitted PQRs and current procedures.</span>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-lg-12">
            <div className="qt-card">
              <span>What is driving the rejection rate increase on the East River project this month?</span>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-lg-12">
            <div className="qt-card">
              <span>Generate a complete end of project quality report for client handover.</span>
            </div>
          </div>
        </div>

      </div>
      <div className="rellax col-12 col-lg-7 col-xl-7 col-xxl-6 offset-xxl-1 px-3 px-sm-4 px-lg-3" data-rellax-percentage="0.5" data-rellax-speed="-0.6" data-disable-parallax-down="lg">
        <video
          src={`${process.env.PUBLIC_URL}/assets/home_page/v3/videos/chat-video.mp4`}
          className="d-block w-100 chat-video"
          autoPlay
          loop
          muted
          playsInline
        />
      </div>
    </div>
  </section>
  );
}

export default TalkToProject;
